<section
  class="new-user-dialog"
  [class.success-dialog]="createdUserEmail"
  [class.duplicate-name-state]="duplicateNameUsers.length > 0"
  *ngIf="newUserFlow"
  aria-labelledby="add-user-title"
>
  <ng-container
    *ngIf="!createdUserEmail && !existingUser && !duplicateNameUsers.length"
  >
    <header class="new-user-header">
      <button
        type="button"
        class="icon-button"
        (click)="closeNewUserDialog()"
        [disabled]="creatingUser"
        [attr.aria-label]="'ADD_USER_BACK' | translate"
      >
        <img src="/assets/svg/ico-chevron-back-outline.svg" alt="" />
      </button>
      <h1 id="add-user-title">{{ "USER_ADD_USER" | translate }}</h1>
      <button
        type="button"
        class="icon-button"
        (click)="closeNewUserDialog()"
        [disabled]="creatingUser"
        [attr.aria-label]="'ADD_USER_CLOSE' | translate"
      >
        <img src="/assets/svg/ico-hamburger-close.svg" alt="" />
      </button>
    </header>
    <h2>{{ "USER_NEW_USER" | translate }}</h2>
    <div class="mobile-access-notice">
      <span class="information-icon" aria-hidden="true">i</span>
      <span>{{ "ADD_USER_MOBILE_ACCESS_NOTICE" | translate }}</span>
    </div>
    <form
      [formGroup]="newUserForm"
      (ngSubmit)="createNewUser()"
      class="new-user-form"
      novalidate
    >
      <fieldset [disabled]="creatingUser">
        <div class="new-user-field">
          <label
            for="new-user-first-name"
            *ngIf="!newUserForm.get('firstName')?.value"
            >{{ "ADD_USER_FIRST_NAME" | translate }}
            <span class="required-mark">*</span></label
          >
          <input
            id="new-user-first-name"
            formControlName="firstName"
            autocomplete="given-name"
            maxlength="32"
            required
            [attr.aria-label]="'ADD_USER_FIRST_NAME' | translate"
          />
        </div>
        <div class="new-user-field">
          <input
            formControlName="middleName"
            autocomplete="additional-name"
            maxlength="32"
            [placeholder]="'ADD_USER_MIDDLE_NAME_OPTIONAL' | translate"
            [attr.aria-label]="'ADD_USER_MIDDLE_NAME_OPTIONAL' | translate"
          />
        </div>
        <div class="new-user-field">
          <label
            for="new-user-last-name"
            *ngIf="!newUserForm.get('lastName')?.value"
            >{{ "ADD_USER_LAST_NAME" | translate }}
            <span class="required-mark">*</span></label
          >
          <input
            id="new-user-last-name"
            formControlName="lastName"
            autocomplete="family-name"
            maxlength="32"
            required
            [attr.aria-label]="'ADD_USER_LAST_NAME' | translate"
          />
        </div>
        <div class="new-user-field">
          <input
            type="email"
            formControlName="email"
            autocomplete="email"
            [placeholder]="'ADD_USER_EMAIL_OPTIONAL' | translate"
            [attr.aria-label]="'ADD_USER_EMAIL_OPTIONAL' | translate"
          />
        </div>
        <div class="new-user-phone-row">
          <div class="region-field">
            <label for="new-user-region">{{
              "ADD_USER_REGION" | translate
            }}</label>
            <span class="region-flag" aria-hidden="true">🇺🇸</span>
            <select
              id="new-user-region"
              formControlName="region"
              [attr.aria-label]="'ADD_USER_REGION' | translate"
            >
              <option value="+1">+1</option>
            </select>
          </div>
          <div class="new-user-field">
            <input
              type="tel"
              formControlName="phone"
              autocomplete="tel-national"
              [placeholder]="'ADD_USER_MOBILE_OPTIONAL' | translate"
              [attr.aria-label]="'ADD_USER_MOBILE_OPTIONAL' | translate"
            />
          </div>
        </div>
        <div class="new-user-field new-user-notes-field">
          <textarea
            formControlName="notes"
            maxlength="100"
            rows="1"
            appNoteInput
            [placeholder]="'ADD_USER_NOTES_OPTIONAL' | translate"
            [attr.aria-label]="'ADD_USER_NOTES_OPTIONAL' | translate"
          ></textarea>
          <span class="note-counter"
            >{{ newUserForm.get("notes")?.value?.length || 0 }}/100</span
          >
        </div>
      </fieldset>
      <div class="new-user-errors" aria-live="polite">
        <span
          *ngIf="
            (newUserForm.get('firstName')?.touched &&
              newUserForm.get('firstName')?.invalid) ||
            (newUserForm.get('lastName')?.touched &&
              newUserForm.get('lastName')?.invalid) ||
            (newUserForm.get('middleName')?.touched &&
              newUserForm.get('middleName')?.invalid)
          "
          >{{ "ADD_USER_INVALID_NAME" | translate }}</span
        >
        <span
          *ngIf="
            newUserForm.get('email')?.touched &&
            newUserForm.get('email')?.invalid
          "
          >{{ "PLEASE_ENTER_A_VALID_EMAIL" | translate }}</span
        >
        <span
          *ngIf="
            newUserForm.get('phone')?.touched &&
            newUserForm.get('phone')?.invalid
          "
          >{{ "WRONG_PHONE" | translate }}</span
        >
      </div>
      <button
        type="submit"
        class="new-user-primary"
        [disabled]="newUserForm.invalid || creatingUser || !siteId"
        [attr.aria-busy]="creatingUser"
      >
        {{ "CONTINUE" | translate }}
      </button>
    </form>
  </ng-container>
  <div *ngIf="duplicateNameUsers.length" class="duplicate-name-dialog">
    <header class="new-user-header">
      <button
        type="button"
        class="icon-button"
        (click)="duplicateNameUsers = []"
        [attr.aria-label]="'ADD_USER_BACK' | translate"
      >
        <img src="/assets/svg/ico-chevron-back-outline.svg" alt="" />
      </button>
      <h1 id="add-user-title">{{ "USER_ADD_USER" | translate }}</h1>
      <button
        type="button"
        class="icon-button"
        (click)="closeNewUserDialog()"
        [attr.aria-label]="'ADD_USER_CLOSE' | translate"
      >
        <img src="/assets/svg/ico-hamburger-close.svg" alt="" />
      </button>
    </header>
    <h2>{{ "ADD_USER_DUPLICATE_NAME_TITLE" | translate }}</h2>
    <p class="duplicate-name-description">
      {{ "ADD_USER_DUPLICATE_NAME_DESCRIPTION" | translate }}
    </p>
    <div class="duplicate-name-list" role="list">
      <button
        type="button"
        class="duplicate-user-card"
        role="listitem"
        *ngFor="let duplicateUser of duplicateNameUsers"
        (click)="openDuplicateUserProfile(duplicateUser)"
        [disabled]="!duplicateUser.email"
      >
        <span class="duplicate-user-avatar">
          <span>{{ duplicateUserInitials(duplicateUser) }}</span>
          <span
            class="duplicate-user-state"
            [class.is-active]="duplicateUser.userType !== 9"
            [class.is-pending]="duplicateUser.userType === 9"
            aria-hidden="true"
          >
            <svg
              *ngIf="duplicateUser.userType !== 9"
              viewBox="0 0 20 20"
              focusable="false"
            >
              <path d="M5 10l3 3 7-8" />
            </svg>
            <svg
              *ngIf="duplicateUser.userType === 9"
              viewBox="0 0 20 20"
              focusable="false"
            >
              <circle cx="10" cy="10" r="6.5" stroke-dasharray="1 2.4" />
              <circle class="pending-status-dot" cx="7" cy="10" r=".8" />
              <circle class="pending-status-dot" cx="10" cy="10" r=".8" />
              <circle class="pending-status-dot" cx="13" cy="10" r=".8" />
            </svg>
          </span>
        </span>
        <span class="duplicate-user-copy">
          <strong>{{ duplicateUserName(duplicateUser) }}</strong>
          <span class="duplicate-user-meta">
            <span class="duplicate-user-role">{{
              duplicateUserType(duplicateUser)
            }}</span>
            <span class="duplicate-user-separator" aria-hidden="true">•</span>
            <span
              class="duplicate-user-status"
              [class.pending]="duplicateUser.userType === 9"
            >
              {{
                duplicateUser.userType === 9
                  ? ("ADD_USER_PENDING_ACCESS" | translate)
                  : ("ACTIVE" | translate)
              }}
            </span>
          </span>
        </span>
        <span class="duplicate-user-chevron" aria-hidden="true">›</span>
      </button>
    </div>
    <div class="duplicate-name-actions">
      <button
        type="button"
        class="new-user-primary"
        (click)="continueWithNewUser()"
        [disabled]="creatingUser"
        [attr.aria-busy]="creatingUser"
      >
        {{ "ADD_USER_CONTINUE_WITH_NEW_USER" | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="existingUser" class="existing-user-dialog">
    <header class="new-user-header">
      <button
        type="button"
        class="icon-button"
        (click)="useDifferentEmail()"
        [attr.aria-label]="'ADD_USER_BACK' | translate"
      >
        <img src="/assets/svg/ico-chevron-back-outline.svg" alt="" />
      </button>
      <h1 id="add-user-title">{{ "USER_ADD_USER" | translate }}</h1>
      <span class="existing-user-header-spacer" aria-hidden="true"></span>
    </header>
    <h2>
      {{
        (showUserAlreadyOnSite
          ? "ADD_USER_ALREADY_ON_SITE_TITLE"
          : "ADD_USER_EXISTING_ACCOUNT_TITLE"
        ) | translate
      }}
    </h2>
    <p class="existing-user-description">
      {{
        (showUserAlreadyOnSite
          ? "ADD_USER_ALREADY_ON_SITE_DESCRIPTION"
          : "ADD_USER_EXISTING_ACCOUNT_DESCRIPTION"
        ) | translate
      }}
    </p>
    <div class="mobile-access-notice">
      <span class="information-icon" aria-hidden="true">i</span>
      <span>{{
        (showUserAlreadyOnSite
          ? "ADD_USER_ALREADY_ON_SITE_NOTICE"
          : "ADD_USER_EXISTING_ACCOUNT_NOTICE"
        ) | translate
      }}</span>
    </div>
    <dl class="existing-user-details">
      <div>
        <dt>{{ "NAME" | translate }}</dt>
        <dd>{{ existingUserMaskedName }}</dd>
      </div>
      <div>
        <dt>{{ "EMAIL" | translate }}</dt>
        <dd>{{ existingUserDisplayEmail }}</dd>
      </div>
      <div>
        <dt>{{ "PHONE_NUMBER" | translate }}</dt>
        <dd>{{ existingUserMaskedPhone }}</dd>
      </div>
      <div>
        <dt>{{ "USER_TYPE" | translate }}</dt>
        <dd>{{ existingUserType | translate }}</dd>
      </div>
    </dl>
    <div class="existing-user-actions">
      <button
        type="button"
        class="new-user-primary"
        (click)="viewExistingUserProfile()"
      >
        {{ "ADD_USER_CONTINUE_EXISTING" | translate }}
      </button>
      <button
        type="button"
        class="new-user-secondary"
        (click)="useDifferentEmail()"
      >
        {{ "ADD_USER_USE_DIFFERENT_EMAIL" | translate }}
      </button>
    </div>
  </div>
  <ng-container
    *ngIf="createdUserEmail"
    [ngTemplateOutlet]="newUserSuccess"
  ></ng-container>
  <ng-template #newUserSuccess>
    <div class="new-user-success" role="status">
      <header class="new-user-success-header">
        <div>{{ createdUserName }}</div>
        <h1 id="add-user-title">{{ "USER_ADD_USER" | translate }}</h1>
      </header>
      <div class="new-user-success-icon" aria-hidden="true">
        <div>
          <svg viewBox="0 0 48 48" focusable="false">
            <path d="M10 26l10 10L39 12" />
          </svg>
        </div>
      </div>
      <p>
        {{ "ADD_USER_SUCCESS_MESSAGE" | translate : { name: createdUserName } }}
      </p>
      <div class="new-user-success-actions">
        <button
          type="button"
          class="new-user-primary"
          (click)="viewNewUserProfile()"
        >
          {{ "ADD_USER_VIEW_PROFILE" | translate }}
        </button>
        <button
          type="button"
          class="new-user-secondary"
          (click)="addAnotherUser()"
        >
          {{ "ADD_USER_ADD_ANOTHER" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</section>
<div class="modal-main" [formGroup]="formGroup" *ngIf="!newUserFlow">
  <ng-template #backButtonRef>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button pointer-cursor"
      (click)="closeDialog()"
    />
  </ng-template>

  <ng-container *ngIf="!commonAccessControl">
    <app-verify-email
      class="d-none"
      [class.d-block]="stepper === 0"
      formGroupName="Email"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (currentUserEmitter)="currentUserEmitter($event)"
      [(skipStepUserType)]="skipStepUserType"
      [(skipStepBuilding)]="skipStepBuilding"
      [isLoading]="isLoading$ | async"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-verify-email>
    <ng-container *ngIf="stepper === 1">
      <app-user-details
        class="d-none"
        [class.d-block]="stepper === 1"
        formGroupName="userDetails"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        (currentUserEmitter)="currentUserEmitter($event)"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-user-details>
    </ng-container>

    <ng-container *ngIf="stepper === 2">
      <app-user-type
        formGroupName="userTypes"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        [(skipStepBuilding)]="skipStepBuilding"
        [flowType]="CONSTANTS.ADD_USER"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-user-type>
    </ng-container>

    <ng-container *ngIf="stepper === 3">
      <app-building-listing
        formGroupName="buildingList"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        [(selectedUnitAccessPoint)]="selectedUnitAccessPoint"
        [(userGroup)]="userGroup"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-building-listing>
    </ng-container>

    <ng-container *ngIf="stepper === 4">
      <app-access-time
        formGroupName="accessTime"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        [skipStepBuilding]="skipStepBuilding"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-access-time>
    </ng-container>

    <ng-container *ngIf="stepper >= 4">
      <app-access-detail-email
        [class.d-block]="stepper === 5"
        class="d-none"
        [flowType]="CONSTANTS.ADD_USER"
        formGroupName="accessEmail"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        (submitToParent)="submitToParent()"
        [skipStepBuilding]="skipStepBuilding"
        [isLoading]="isLoading$ | async"
        [(userGroup)]="userGroup"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-access-detail-email>
    </ng-container>

    <ng-container *ngIf="stepper >= 5">
      <app-completed
        [class.d-block]="stepper === 6"
        class="d-none"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        (formReset)="formReset()"
      >
      </app-completed>
    </ng-container>

    <ng-container *ngIf="stepper === 8">
      <app-selected-units-accesspoints
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        [(selectedUnitAccessPoint)]="selectedUnitAccessPoint"
        [(userGroup)]="userGroup"
        [sharedData]="sharedData"
        [flowType]="CONSTANTS.ADD_USER"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-selected-units-accesspoints>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="commonAccessControl">
    <app-verify-email
      class="d-none"
      [class.d-block]="stepper === 0"
      formGroupName="Email"
      [dialogRef]="dialogRef"
      [(stepper)]="stepper"
      (currentUserEmitter)="currentUserEmitter($event)"
      [(skipStepUserType)]="skipStepUserType"
      [(skipStepBuilding)]="skipStepBuilding"
      [isLoading]="isLoading$ | async"
    >
      <span backButton>
        <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
      </span>
    </app-verify-email>
    <ng-container *ngIf="stepper === 1">
      <app-user-details
        class="d-none"
        [class.d-block]="stepper === 1"
        formGroupName="userDetails"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        (currentUserEmitter)="currentUserEmitter($event)"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-user-details>
    </ng-container>

    <ng-container *ngIf="stepper === 2">
      <app-user-type
        formGroupName="userTypes"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        [(skipStepBuilding)]="skipStepBuilding"
        [flowType]="CONSTANTS.ADD_USER"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-user-type>
    </ng-container>

    <ng-container *ngIf="stepper === 3">
      <app-user-group
        [(userStepper)]="stepper"
        [(userGroup)]="userGroup"
        [(selectedGroup)]="selectedGroup"
        formGroupUserDetailName="userDetails"
        [skipStepUserType]="skipStepUserType"
        [skipStepBuilding]="skipStepBuilding"
        [userName]="userName"
        [alreadySelectedGroups]="alreadySelectedGroups"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-user-group>
    </ng-container>

    <ng-container *ngIf="stepper === 4">
      <app-building-listing
        formGroupName="buildingList"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        [(selectedUnitAccessPoint)]="selectedUnitAccessPoint"
        [(userGroup)]="userGroup"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-building-listing>
    </ng-container>

    <ng-container *ngIf="stepper === 5">
      <app-access-time
        formGroupName="accessTime"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        [skipStepBuilding]="skipStepBuilding"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-access-time>
    </ng-container>

    <ng-container *ngIf="stepper === 6">
      <app-access-detail-email
        [flowType]="CONSTANTS.ADD_USER"
        formGroupName="accessEmail"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        (submitToParent)="submitToParent()"
        [skipStepBuilding]="skipStepBuilding"
        [isLoading]="isLoading$ | async"
        [(userGroup)]="userGroup"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-access-detail-email>
    </ng-container>

    <ng-container *ngIf="stepper >= 6">
      <app-completed
        [class.d-block]="stepper === 7"
        class="d-none"
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        (formReset)="formReset()"
      >
      </app-completed>
    </ng-container>

    <ng-container *ngIf="stepper === 8">
      <app-selected-units-accesspoints
        [dialogRef]="dialogRef"
        [(stepper)]="stepper"
        [(selectedUnitAccessPoint)]="selectedUnitAccessPoint"
        [(userGroup)]="userGroup"
        [sharedData]="sharedData"
        [flowType]="CONSTANTS.ADD_USER"
      >
        <span backButton>
          <ng-template [ngTemplateOutlet]="backButtonRef"></ng-template>
        </span>
      </app-selected-units-accesspoints>
    </ng-container>
  </ng-container>
</div>
